import React from 'react';
import Spinner from 'js/components/common/Spinner';
import Row from '../Row';
import Container from './Container';

export default props => (
  <Container {...props}>
    <Row cols="auto">
      <Spinner />
    </Row>
  </Container>
);
